import script from "./WordPressContentPage.vue?vue&type=script&setup=true&lang=js"
export * from "./WordPressContentPage.vue?vue&type=script&setup=true&lang=js"

import "./WordPressContentPage.vue?vue&type=style&index=0&id=d4fd09cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4fd09cc"]])

export default __exports__